<h2 mat-dialog-title>{{ 'INBOX.WEBCHAT.LEARN_MORE.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p class="subtitle">{{ 'INBOX.WEBCHAT.LEARN_MORE.WHAT_CAN_DO_QUESTION' | translate }}</p>
  <span class="learn-content">{{ 'INBOX.WEBCHAT.LEARN_MORE.WHAT_CAN_DO' | translate }}</span>

  <p class="subtitle">{{ 'INBOX.WEBCHAT.LEARN_MORE.HOW_IT_WORKS_QUESTION' | translate }}</p>
  <span class="learn-content">{{ 'INBOX.WEBCHAT.LEARN_MORE.HOW_IT_WORKS' | translate }}</span>

  <p class="subtitle">{{ 'INBOX.WEBCHAT.LEARN_MORE.HOW_TO_GET_MOST_QUESTION' | translate }}</p>
  <span class="learn-content">{{ 'INBOX.WEBCHAT.LEARN_MORE.HOW_TO_GET_MOST' | translate }}</span>

  <p class="subtitle">{{ 'INBOX.WEBCHAT.LEARN_MORE.HOW_TEST_IT_QUESTION' | translate }}</p>
  <span class="learn-more-content">{{ 'INBOX.WEBCHAT.LEARN_MORE.HOW_TEST_IT' | translate }}</span>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" mat-dialog-close>{{ 'INBOX.CLOSE' | translate }}</button>
</mat-dialog-actions>
